// @vendors
import React, { useMemo, useState } from 'react'
import {
    Box,
    TextField,
    Button,
    FormControlLabel,
    Checkbox,
} from '../../../components/shared/MaterialUI';
import SearchIcon from '@mui/icons-material/Search'
import { useHistory } from 'react-router-dom';

// @styles
import { EmployerStyles } from '../../../assets/css/employer-style';
import { GeneralStyles } from '../../../assets/css/general-style';

// @helpers
import { ROUTENAME } from '../../../navigation/RouteName';
import { theme } from '../../../assets/theme';

const SearchGlobal = () => {
  const history = useHistory();
  const styles = useMemo(() => EmployerStyles(), []);
  const generalStyle = useMemo(() => GeneralStyles(), []);
  const [searchType, setSearchType] = useState('employees');
  const [searchText, setSearchText] = useState('');

  const handleCheckboxChange = (type) => {
    setSearchType(type)
  }

  const handleSearch = () => {
    if(searchType === 'company')return history.push(`${ROUTENAME.dashboard}?search=${searchText}`);
    return history.push(`${ROUTENAME.searchEmployees}?search=${searchText}`);
  }

  return (
    <Box sx={styles.containerSearchGlobal}>
      <Box sx={{ display: 'flex', gap: 0 }}>
        <FormControlLabel
          checked={searchType === 'employees'}
          sx={{ margin: 0, color: theme.palette.secondary.black }}
          control={
            <Checkbox
              sx={{...styles.checkboxCustom, '& .MuiSvgIcon-root': { fontSize: 30 } }}
              color="success"
              onChange={() => handleCheckboxChange('employees')}
            />
          }
          label="Employees"
        />
        <FormControlLabel
          checked={searchType === 'company'}
          sx={{ margin: 0, color: theme.palette.secondary.black }}
          control={
            <Checkbox
              sx={{...styles.checkboxCustom, '& .MuiSvgIcon-root': { fontSize: 30 } }}
              color="success"
              onChange={() => handleCheckboxChange('company')}
            />
          }
          label="Company"
        />
      </Box>

      <Box sx={styles.containerInputSearchGlobal}>
        <TextField
          fullWidth
          variant="outlined"
          label="Search global"
          placeholder={`Search ${searchType === 'company' ? 'company' : 'employees'}...`}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          sx={{ ...generalStyle.input, ...generalStyle.customButtonSm}}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              handleSearch()
            }
          }}
        />
        <Button
          variant="contained"
          startIcon={<SearchIcon />}
          onClick={handleSearch}
          sx={{
            ...generalStyle.customButtonMain,
            ...generalStyle.customButtonSm,
            width: '150px',
          }}
        >
          Search
        </Button>
      </Box>
    </Box>
  )
}

export default SearchGlobal